
export default {
  validate: function (value) {
    return !(/(.)\1{2}/.test(value))
  }
}



// WEBPACK FOOTER //
// ./src/config/validate/rules/repeatChar.js